import React from 'react';
import { motion } from 'framer-motion';
import { Fingerprint, Database, Infinity, ArrowRight } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-5 relative overflow-hidden" data-id="element-114">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#00d4ff]/5 rounded-[100%] blur-[120px] pointer-events-none" data-id="element-115" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-118">
            El Secreto:{' '}
            <span className="text-gradient-cyan" data-id="element-119">
              El Ancla de Realismo + Dataset Sólido.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-120">
            No es un curso de "cómo escribir prompts". Es un{' '}
            <strong className="text-white" data-id="element-121">Método Operativo</strong>. Te enseño
            a crear la "huella genética" de tu avatar para que, sin importar el
            escenario, la luz o la pose, el rostro sea 100% el mismo.
          </p>
        </motion.div>

        {/* Visual Diagram */}
        <div className="mt-16 relative" data-id="element-122">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-[#00d4ff]/30 to-transparent -translate-y-1/2 z-0" data-id="element-123" />

          <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-124">
            {/* Step 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="glass-card p-8 rounded-2xl flex flex-col items-center text-center relative group" data-id="element-125">
              <div className="w-16 h-16 rounded-full bg-[#1a1a24] border border-white/10 flex items-center justify-center mb-6 group-hover:border-[#00d4ff]/50 transition-colors shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-126">
                <Fingerprint className="w-8 h-8 text-gray-400 group-hover:text-[#00d4ff] transition-colors" data-id="element-127" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-128">
                1. Foto Semilla
              </h3>
              <p className="text-sm text-gray-400" data-id="element-129">
                Creación de la identidad base perfecta, con textura de piel real
                y proporciones únicas.
              </p>

              <ArrowRight className="md:hidden w-6 h-6 text-gray-600 mt-6" data-id="element-130" />
            </motion.div>

            {/* Step 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="glass-card p-8 rounded-2xl flex flex-col items-center text-center relative group border-[#00d4ff]/20 bg-[#111118]/90" data-id="element-131">
              <div className="absolute inset-0 bg-[#00d4ff]/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-132" />
              <div className="w-16 h-16 rounded-full bg-[#1a1a24] border border-[#00d4ff]/30 flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(0,212,255,0.2)]" data-id="element-133">
                <Database className="w-8 h-8 text-[#00d4ff]" data-id="element-134" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-135">
                2. Dataset Ancla
              </h3>
              <p className="text-sm text-gray-400" data-id="element-136">
                Entrenamiento del modelo con ángulos específicos para fijar la
                "huella genética".
              </p>

              <ArrowRight className="md:hidden w-6 h-6 text-gray-600 mt-6" data-id="element-137" />
            </motion.div>

            {/* Step 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="glass-card p-8 rounded-2xl flex flex-col items-center text-center relative group" data-id="element-138">
              <div className="w-16 h-16 rounded-full bg-[#1a1a24] border border-white/10 flex items-center justify-center mb-6 group-hover:border-[#7c3aed]/50 transition-colors shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-139">
                <Infinity className="w-8 h-8 text-gray-400 group-hover:text-[#7c3aed] transition-colors" data-id="element-140" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-141">
                3. Clon Infinito
              </h3>
              <p className="text-sm text-gray-400" data-id="element-142">
                Generación ilimitada en cualquier escenario, manteniendo el 100%
                de consistencia facial.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}